// src/components/layouts/FonctionelLayout.jsx
import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import FonctionelTaskToolbar from '../pages/fonctionel/TaskToolbar';
import AddTaskForm from '../pages/fonctionel/AddTaskForm';
import axios from 'axios';
import api from '../api';


const FonctionelLayout = () => {
  const navigate = useNavigate();
  
  // ✅ États pour les filtres - alignés avec TechniqueLayout
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateStart, setDateStart] = useState(null); // ✅ Changé de '' à null
  const [dateEnd, setDateEnd] = useState(null); // ✅ Changé de '' à null
  const [dateStartTech, setDateStartTech] = useState('');
  const [dateEndTech, setDateEndTech] = useState('');
  const [dateDeadlineClientStart, setDateDeadlineClientStart] = useState('');
  const [dateDeadlineClientEnd, setDateDeadlineClientEnd] = useState('');
  
  // ✅ Alignement avec TechniqueLayout - null au lieu de ''
  const [priorityFilter, setPriorityFilter] = useState(null);
  const [typeFilter, setTypeFilter] = useState(null);
  const [moduleFilter, setModuleFilter] = useState(null);
  const [organisationFilter, setOrganisationFilter] = useState(null);
  const [deadlineTechFilter, setDeadlineTechFilter] = useState(null);
  const [deadlineClientFilter, setDeadlineClientFilter] = useState(null);
   const [fonctionnelId, setFonctionnelId] = useState(null);

  // États pour les données
  const [organisations, setOrganisations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState('');

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const userResponse = await api.get('/me', { withCredentials: true });
        if (!userResponse.data.success) {
          console.error('Impossible de récupérer les informations utilisateur.');
          return;
        }

        const user = userResponse.data.user;
        setFonctionnelId(parseInt(user.id, 10));
        console.log('Fonctionnel ID:', fonctionnelId);
      } catch (error) {
        console.error('Erreur lors de la récupération des informations utilisateur.');
      }
    };

    fetchUser();
  }, []);



  // Charger les organisations du fonctionnel
  useEffect(() => {
    if (fonctionnelId) {
      api.get(`/organisations/fonctionnel/${fonctionnelId}`)
        .then(res => {  
          const orgs = res.data.organisations || [];
          setOrganisations(orgs);
        })
        .catch(err => console.error('Erreur chargement organisations:', err));
    }
  }, [fonctionnelId]);

  // ✅ Actions - alignées avec TechniqueLayout
  const handleShowForm = () => setShowForm(true);
  const handleSearch = (value) => setSearchTerm(value);
  const handleDateStart = (value) => setDateStart(value);
  const handleDateEnd = (value) => setDateEnd(value);
  const handleDateStartTech = (value) => setDateStartTech(value);
  const handleDateEndTech = (value) => setDateEndTech(value);
  const handleDateDeadlineClientStart = (value) => setDateDeadlineClientStart(value);
  const handleDateDeadlineClientEnd = (value) => setDateDeadlineClientEnd(value);
  
  // ✅ Correction des handlers pour gérer null comme TechniqueLayout
  const handlePriorityChange = (value) => setPriorityFilter(value || null);
  const handleTypeChange = (value) => setTypeFilter(value || null);
  const handleModuleChange = (value) => setModuleFilter(value || null);
  const handleOrganisationChange = (value) => {
    setOrganisationFilter(value || null);
    setSelectedOrg(value || ''); // ✅ Maintien de la logique spécifique fonctionnel
  };
  const handleDeadlineTechChange = (value) => setDeadlineTechFilter(value || null);
  const handleDeadlineClientChange = (value) => setDeadlineClientFilter(value || null);

  // ✅ Fonction de réinitialisation alignée avec TechniqueLayout
  const handleResetFilters = () => {
    setSearchTerm('');
    setDateStart(null); // ✅ null au lieu de ''
    setDateEnd(null); // ✅ null au lieu de ''
    setDateStartTech('');
    setDateEndTech('');
    setDateDeadlineClientStart('');
    setDateDeadlineClientEnd('');
    setPriorityFilter(null); // ✅ null au lieu de ''
    setTypeFilter(null); // ✅ null au lieu de ''
    setModuleFilter(null); // ✅ null au lieu de ''
    setOrganisationFilter(null); // ✅ null au lieu de ''
    setSelectedOrg(''); // ✅ Maintien pour la logique fonctionnel
    setDeadlineTechFilter(null); // ✅ null au lieu de ''
    setDeadlineClientFilter(null); // ✅ null au lieu de ''
  };

const handleLogout = async () => {
  try {
    await api.post('/logout'); // Appel vers Laravel
    localStorage.clear();      // Nettoyer localStorage
    navigate('/');             // Rediriger vers login
  } catch (error) {
    console.error('Erreur logout :', error);
    alert('Impossible de se déconnecter.');
  }
};

  const handleAddTask = (newTask) => {
    console.log('Nouvelle tâche ajoutée :', newTask);
    setShowForm(false);
    // Vous pouvez déclencher un rechargement des données ici si nécessaire
  };

  // ✅ Valeurs actuelles à passer à la toolbar - alignées avec TechniqueLayout
  const currentValues = {
    searchTerm,
    dateStart,
    dateEnd,
    dateStartTech,
    dateEndTech,
    dateDeadlineClientStart,
    dateDeadlineClientEnd,
    priorityFilter,
    typeFilter,
    moduleFilter,
    organisationFilter,
    deadlineTechFilter,
    deadlineClientFilter
  };

  // ✅ Contexte à passer aux pages enfants - format simplifié comme TechniqueLayout
  const contextValue = {
    // Filtres principaux
    searchTerm,
    dateStart,
    dateEnd,
    priorityFilter,
    typeFilter,
    moduleFilter,
    organisationFilter,
    deadlineTechFilter,
    deadlineClientFilter,
    
    // Filtres spécifiques fonctionnel
    dateStartTech,
    dateEndTech,
    dateDeadlineClientStart,
    dateDeadlineClientEnd,
    selectedOrg,
    organisations,
    
    // Formulaire
    showForm,
    setShowForm
  };

  return (
    <div className="flex flex-col h-screen">
      <FonctionelTaskToolbar
        onShowForm={handleShowForm}
        onSearch={handleSearch}
        onDateStartChange={handleDateStart}
        onDateEndChange={handleDateEnd}
        onDateStartTechChange={handleDateStartTech}
        onDateEndTechChange={handleDateEndTech}
        onDateDeadlineClientStartChange={handleDateDeadlineClientStart}
        onDateDeadlineClientEndChange={handleDateDeadlineClientEnd}
        onPriorityChange={handlePriorityChange}
        onTypeChange={handleTypeChange}
        onModuleChange={handleModuleChange}
        onOrganisationChange={handleOrganisationChange}
        onDeadlineTechChange={handleDeadlineTechChange}
        onDeadlineClientChange={handleDeadlineClientChange}
        onResetFilters={handleResetFilters}
        onLogout={handleLogout}
        currentValues={currentValues}
        organisations={organisations}
        selectedOrg={selectedOrg}
      />

      {showForm && (
        <AddTaskForm
          onClose={() => setShowForm(false)}
          onAddTask={handleAddTask}
          organisations={organisations}
          selectedOrg={selectedOrg}
        />
      )}

      {/* ✅ Passage du contexte simplifié comme TechniqueLayout */}
      <Outlet context={contextValue} />
    </div>
  );
};

export default FonctionelLayout;